import React, { useState, useEffect } from "react";
import "./ThinkingBlock.css";

const SparkleIcon = () => (
  <svg className="thinking-sparkle-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l2.4 7.2L21.6 11.6l-7.2 2.4L12 21.2l-2.4-7.2L2.4 11.6l7.2-2.4z" />
  </svg>
);

interface ThinkingBlockProps {
  title?: string;
  thinkingText?: string;
  isThinking?: boolean;
}

export const ThinkingBlock: React.FC<ThinkingBlockProps> = ({
  title,
  thinkingText = "",
  isThinking = false,
}) => {
  const [isOpen, setIsOpen] = useState(isThinking);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    let interval: any = null;
    if (isThinking) {
      setElapsedSeconds(0);
      const startTime = Date.now();
      interval = setInterval(() => {
        setElapsedSeconds(Number(((Date.now() - startTime) / 1000).toFixed(1)));
      }, 100);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isThinking]);

  return (
    <div className={`thinking-block ${isThinking ? "thinking-block--active" : ""}`}>
      <button
        type="button"
        className="thinking-block__header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <SparkleIcon />
        {isThinking ? (
          <span className="thinking-block__status">
            {title ? title : "思考中"}<span className="thinking-dots">...</span>
            <span className="thinking-timer">{elapsedSeconds.toFixed(1)}s</span>
          </span>
        ) : (
          <span className="thinking-block__status">
            {title ? title.replace("正在", "已").replace("...", "") : "已深度思考"} <span className="thinking-timer">{elapsedSeconds > 0 ? elapsedSeconds.toFixed(1) : "1.8"}s</span>
          </span>
        )}
        <span className="thinking-block__arrow">{isOpen ? "▲" : "▼"}</span>
      </button>

      {isOpen && (
        <div className="thinking-block__body">
          <div className="thinking-block__content">
            {thinkingText.trim() ? (
              thinkingText
            ) : (
              <span className="thinking-placeholder">正在推理分析中...</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThinkingBlock;
